import { coefficientField } from './PriceListFormConfig';

const fields = {
  config: { columns: 2 },
  fields: [
    {
      name: "tmpId",
      column: 1,
      type: "unvisible",
    },

    {
      name: 'dates',
      label: 'Współczynnik obowiązuje od - do',
      column: 1,
      type: 'dateRange',
      mandatory: true,
      startField: 'startDate',
      endField: 'endDate',
      excludedDates: [],
      excludedStartDates: [],
      excludedEndDates: [],
      fromLabel: 'Data startu',
      toLabel: 'Data końca',
    },
    coefficientField(undefined, 2, 'coefficient', 'Współczynnik'),
  ],
};

export default fields;
